import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhatWeDo from "@/components/WhatWeDo";
import SelectedWork from "@/components/SelectedWork";
import Capabilities from "@/components/Capabilities";
import BottomStrip from "@/components/BottomStrip";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ProjectsPage from "@/pages/ProjectsPage";
import ServicePage from "@/pages/ServicePage";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/lenis";
import { ContentProvider } from "@/lib/content";

const Home = () => {
  const [showNav, setShowNav] = useState(false);
  const location = useLocation();

  // Support returning to a specific section, e.g. /?section=contact
  useEffect(() => {
    const target = new URLSearchParams(location.search).get("section");
    if (!target) return;
    const t = setTimeout(() => {
      document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
    }, 700);
    return () => clearTimeout(t);
  }, [location.search]);

  return (
    <>
      <Navbar visible={showNav} />
      <Hero onAssembled={setShowNav} />
      <main>
        <WhatWeDo />
        <SelectedWork />
        <Capabilities />
        <BottomStrip />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App grain relative bg-[#0a0a0c] text-white antialiased">
      <BrowserRouter>
        <ContentProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<ProjectsPage />} />
            <Route path="/projects" element={<Navigate to="/work" replace />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </ContentProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#101012",
            border: "1px solid #26262a",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
